import { useCallback } from 'react';
import { useOfficeLocationStore } from '../store/officeLocationStore';
import { OfficeLocationFormData } from '../types';

export const useOfficeLocationFormState = (formId: string | number) => {
  const formData = useOfficeLocationStore(
    (state) => state.forms[formId]?.formData || ({} as Partial<OfficeLocationFormData>),
  );

  const formErrors = useOfficeLocationStore(
    (state) =>
      state.forms[formId]?.errors || ({} as Partial<Record<keyof OfficeLocationFormData, string>>),
  );

  const isSubmitting = useOfficeLocationStore((state) => state.isSubmitting);

  const setFieldValue = useOfficeLocationStore((state) => state.setFieldValue);
  const setFieldError = useOfficeLocationStore((state) => state.setFieldError);
  const clearFieldError = useOfficeLocationStore((state) => state.clearFieldError);
  const removeForm = useOfficeLocationStore((state) => state.removeForm);

  const updateField = useCallback(
    (field: keyof OfficeLocationFormData, value: any) => {
      setFieldValue({ formId, field, value });
    },
    [formId, setFieldValue],
  );

  const setError = useCallback(
    (field: keyof OfficeLocationFormData, error: string) => {
      setFieldError({ formId, field, error });
    },
    [formId, setFieldError],
  );

  const clearError = useCallback(
    (field: keyof OfficeLocationFormData) => {
      clearFieldError({ formId, field });
    },
    [formId, clearFieldError],
  );

  const deleteForm = useCallback(() => {
    removeForm(formId);
  }, [formId, removeForm]);

  return {
    formData,
    formErrors,
    isSubmitting,
    updateField,
    setError,
    clearError,
    deleteForm,
  };
};
